import { render, staticRenderFns } from "./ToDoCard.vue?vue&type=template&id=9bb016e8"
import script from "./ToDoCard.vue?vue&type=script&lang=js"
export * from "./ToDoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports